import type { NextPage, NextPageContext } from 'next'

import type { IMicrositePageProps } from '@microsites/types'
import { getMicrositeInitialProps } from '@microsites/utils/microsites/getMicrositeInitialProps'

import MicrositePage from '../MicrositePage'

import Channel from './Channel'

/**
 *
 */
export const ChannelPage: NextPage<IMicrositePageProps> = (props) => {
  if (!props.ssrPage) {
    return <Channel {...props} />
  }
  return <MicrositePage {...props} />
}

ChannelPage.getInitialProps = async (
  context: NextPageContext,
): Promise<IMicrositePageProps> => {
  return await getMicrositeInitialProps(context)
}

export default ChannelPage
